import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent, ButtonComponent } from '@simac/ui';
import { WebshopService } from '../services/webshop.service';

@Component({
  selector: 'app-shopping-cart-button',
  imports: [ButtonComponent],
  templateUrl: './shopping-cart-button.component.html',
  styleUrl: './shopping-cart-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingCartButtonComponent extends BaseComponent {
  readonly webshopService = inject(WebshopService);
  private readonly router = inject(Router);

  constructor() {
    super();
  }

  toSSPShoppingCart(): void {
    if (this.webshopService.hasCustomPermission) {
      this.router.navigate(['custom-webshop', 'shopping-cart']);
      return;
    }
    this.router.navigate(['webshop', 'shopping-cart']);
  }
}
